import React from 'react';
import { findByAlias } from '../../../routes';
import { WarrantyInformationView } from '../../../views';

export const WarrantyInformationViewStep = (): string => {
    return findByAlias('WarrantyInformationViewRoute');
};

export const WarrantyWrapper: React.FunctionComponent = (): React.ReactElement => {
    return <WarrantyInformationView />;
};
export default WarrantyWrapper;
